import { render, staticRenderFns } from "./reminder.vue?vue&type=template&id=11e08095&scoped=true"
import script from "./reminder.vue?vue&type=script&lang=js"
export * from "./reminder.vue?vue&type=script&lang=js"
import style0 from "./reminder.vue?vue&type=style&index=0&id=11e08095&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_0a317e13ddfbb0b64829e4e877bda568/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11e08095",
  null
  
)

export default component.exports